import { all, takeEvery, put, call } from 'redux-saga/effects';
import api from '../../../services/api';
import { Types } from './actions';
import { AnyAction } from 'redux';
import { ApiTypes } from 'models/index';
import { removeEmptyParams } from 'utils/removeEmptyParams';

export function* GET_DUTY_TIMES(action: AnyAction) {
  const params: Record<string, string> = {
    order: action.payload?.order,
    limit: action.payload.limit,
    page: action.payload.page,
    user_ids: action.payload?.user_ids,
    active: action.payload?.active,
  };

  const paramsCleared = removeEmptyParams(params);

  try {
    const response: ApiTypes.ResponseGenerator = yield call(
      api.get,
      `/v1/companies/${action.payload.companyID}/duty-times`,
      { params: paramsCleared },
    );

    if (response.status === 200) {
      yield put({
        type: Types.GET_DUTY_TIMES_SUCCESS,
        payload: response.data?.Data,
      });

      yield put({
        type: Types.SET_TOTAL_COUNT,
        payload: response.data?.Total,
      });
    }
  } catch (error) {
    yield put({ type: Types.GET_DUTY_TIMES_ERROR });
  }
}

export default function* rootSaga() {
  yield all([takeEvery(Types.GET_DUTY_TIMES_REQUEST, GET_DUTY_TIMES)]);
}
